import type { AppState } from "../types/models";
import { load, save } from "./persistence";

type Listener = () => void;

let state: AppState = load() ?? {
    classes: [],
    activeClassId: null
};

const listeners = new Set<Listener>();

// Helper function to compute state diff
function computeStateDiff(oldState: AppState, newState: AppState): object {
    const diff: any = {};

    if (oldState.activeClassId !== newState.activeClassId) {
        diff.activeClassId = `${oldState.activeClassId} → ${newState.activeClassId}`;
    }

    if (oldState.classes.length !== newState.classes.length) {
        diff.classCount = `${oldState.classes.length} → ${newState.classes.length}`;
    }

    // Detect changed classes (simplified - just check if they're different)
    const changedClasses = newState.classes.filter((cls, idx) => {
        const old = oldState.classes[idx];
        return !old || JSON.stringify(old) !== JSON.stringify(cls);
    });

    if (changedClasses.length > 0) {
        diff.changedClasses = changedClasses.map(c => c.id);
    }

    return diff;
}

export function getState(): AppState { return state; }

export function setState(mutator: (s: AppState) => void): void {
    const draft = structuredClone(state);
    mutator(draft);
    state = draft;

    save(state);
    listeners.forEach(fn => fn());
    document.dispatchEvent(new CustomEvent("state:update"));
}

export function subscribe(fn: Listener): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
}
